"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operators = void 0;
var _operators = require("@kentik/ui-shared/dictionary/operators");
const operators = exports.operators = {
  src_cloud: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  dst_cloud: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  'src|dst_cloud': {
    '=': 'equals',
    '<>': 'does not equal'
  },
  src_cloud_service: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  dst_cloud_service: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  'src|dst_cloud_service': {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_input_vrf: _operators.stringOperators,
  i_output_vrf: _operators.stringOperators,
  'i_input|output_vrf': _operators.stringOperators,
  input_vrf: _operators.intOperators,
  output_vrf: _operators.intOperators,
  'input|output_vrf': _operators.intOperators,
  i_input_vrf_rd: _operators.stringOperators,
  i_output_vrf_rd: _operators.stringOperators,
  'i_input|output_vrf_rd': _operators.stringOperators,
  i_input_vrf_rt: _operators.stringOperators,
  i_output_vrf_rt: _operators.stringOperators,
  'i_input|output_vrf_rt': _operators.stringOperators,
  i_dst_rpki_name: _operators.stringOperators,
  i_dst_rpki_min_name: _operators.stringOperators,
  dscp: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  ecn: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  kflow_http_status: _operators.intOperators,
  src_threat_bnetcc: _operators.stringOperators,
  dst_threat_bnetcc: _operators.stringOperators,
  'src|dst_threat_bnetcc': _operators.stringOperators,
  src_threat_host: _operators.stringOperators,
  dst_threat_host: _operators.stringOperators,
  'src|dst_threat_host': _operators.stringOperators,
  src_cdn: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  dst_cdn: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  'src|dst_cdn': {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  input_port: _operators.intOperators,
  output_port: _operators.intOperators,
  'input|output_port': _operators.intOperators,
  ult_exit_port: _operators.intOperators,
  vlan_in: _operators.intOperators,
  vlan_out: _operators.intOperators,
  'vlan_in|out': _operators.intOperators,
  l4_src_port: _operators.intOperators,
  l4_dst_port: _operators.intOperators,
  'l4_src|dst_port': _operators.intOperators,
  src_as: _operators.intOperators,
  dst_as: _operators.intOperators,
  'src|dst_as': _operators.intOperators,
  src_nexthop_as: _operators.intOperators,
  dst_nexthop_as: _operators.intOperators,
  'src|dst_nexthop_as': _operators.intOperators,
  src_second_asn: _operators.intOperators,
  dst_second_asn: _operators.intOperators,
  'src|dst_second_asn': _operators.intOperators,
  src_third_asn: _operators.intOperators,
  dst_third_asn: _operators.intOperators,
  'src|dst_third_asn': _operators.intOperators,
  src_secondhop_asn_noprepend: _operators.intOperators,
  dst_secondhop_asn_noprepend: _operators.intOperators,
  'src|dst_secondhop_asn_noprepend': _operators.intOperators,
  src_thirdhop_asn_noprepend: _operators.intOperators,
  dst_thirdhop_asn_noprepend: _operators.intOperators,
  'src|dst_thirdhop_asn_noprepend': _operators.intOperators,
  src_asn_generic: _operators.intOperators,
  dst_asn_generic: _operators.intOperators,
  'src|dst_asn_generic': _operators.intOperators,
  i_src_as_name: _operators.stringOperators,
  i_dst_as_name: _operators.stringOperators,
  'i_src|dst_as_name': _operators.stringOperators,
  i_src_nexthop_as_name: _operators.stringOperators,
  i_dst_nexthop_as_name: _operators.stringOperators,
  'i_src|dst_nexthop_as_name': _operators.stringOperators,
  i_src_second_asn_name: _operators.stringOperators,
  i_dst_second_asn_name: _operators.stringOperators,
  'i_src|dst_second_asn_name': _operators.stringOperators,
  i_src_third_asn_name: _operators.stringOperators,
  i_dst_third_asn_name: _operators.stringOperators,
  'i_src|dst_third_asn_name': _operators.stringOperators,
  i_src_secondhop_asn_noprepend_name: _operators.stringOperators,
  i_dst_secondhop_asn_noprepend_name: _operators.stringOperators,
  'i_src|dst_secondhop_asn_noprepend_name': _operators.stringOperators,
  i_src_thirdhop_asn_noprepend_name: _operators.stringOperators,
  i_dst_thirdhop_asn_noprepend_name: _operators.stringOperators,
  'i_src|dst_thirdhop_asn_noprepend_name': _operators.stringOperators,
  i_src_asn_generic_name: _operators.stringOperators,
  i_dst_asn_generic_name: _operators.stringOperators,
  'i_src|dst_asn_generic_name': _operators.stringOperators,
  src_flow_tags: {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  dst_flow_tags: {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  'src|dst_flow_tags': {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  inet_src_addr: _operators.inetOperators,
  inet_dst_addr: _operators.inetOperators,
  'inet_src|dst_addr': _operators.inetOperators,
  inet_src_next_hop: _operators.inetOperators,
  inet_dst_next_hop: _operators.inetOperators,
  'inet_src|dst_next_hop': _operators.inetOperators,
  inet_src_route_prefix: _operators.inetOperators,
  inet_dst_route_prefix: _operators.inetOperators,
  'inet_src|dst_route_prefix': _operators.inetOperators,
  src_bgp_aspath: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_bgp_aspath: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_bgp_aspath': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_aspath_noprepend: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_aspath_noprepend: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_aspath_noprepend': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_bgp_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_bgp_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_bgp_community': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_bgp_ext_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_bgp_ext_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_bgp_ext_community': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_bgp_large_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_bgp_large_community: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_bgp_large_community': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_bgp_origin: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  dst_bgp_origin: {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  'src|dst_bgp_origin': {
    ..._operators.stringOperators,
    ..._operators.caseSensitiveRegexOperators
  },
  src_route_length: _operators.intOperators,
  dst_route_length: _operators.intOperators,
  'src|dst_route_length': _operators.intOperators,
  application: _operators.stringOperators,
  i_input_interface_description: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_output_interface_description: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  'i_input|output_interface_description': {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_ult_exit_interface_description: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_input_snmp_alias: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_output_snmp_alias: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  'i_input|output_snmp_alias': {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_ult_exit_snmp_alias: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_input_interface_speed: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_output_interface_speed: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  'i_input|output_interface_speed': {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  tcp_flags: {
    '&': 'is set',
    bitwiseNone: 'is not set',
    '=': 'is only set',
    '<>': 'does not equal'
  },
  i_device_id: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Device ID',
    misc_flags_not_set: 'does not match Ultimate Exit Device ID'
  },
  i_device_name: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Device Name',
    misc_flags_not_set: 'does not match Ultimate Exit Device Name'
  },
  i_ult_exit_device_name: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_ult_exit_site: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_ult_exit_site_country: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_ult_exit_vrf: _operators.stringOperators,
  i_ult_exit_vrf_rd: _operators.stringOperators,
  i_site_market: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Site Market',
    misc_flags_not_set: 'does not match Ultimate Exit Site Market'
  },
  i_ult_exit_site_market: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_inet_ult_exit: _operators.inetOperators,
  in_bytes: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  out_bytes: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  in_pkts: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  out_pkts: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  both_pkts: {
    '=': 'equals',
    '<>': 'does not equal',
    '<': 'less than',
    '>': '>'
  },
  sampledpktsize: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  sampledpktsize_100: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  sample_rate: _operators.intOperators,
  tcp_retransmit: {
    '>': 'is greater than'
  },
  inet_family: {
    '=': 'equals'
  },
  ipv6_flow_label: _operators.intOperators,
  tos: {
    '=': 'equals',
    '<>': 'does not equal',
    '>': 'is greater than',
    '<': 'is less than',
    '&': 'Bitwise AND (&)'
  },
  i_device_site_name: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Site',
    misc_flags_not_set: 'does not match Ultimate Exit Site'
  },
  i_device_site_country: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_device_label: {
    '=': 'include',
    '<>': 'do not include'
  },
  kflow_dns_query: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_dns_query_type: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_dns_response: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_http_url: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_http_referer: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_http_ua: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  kflow_http_host: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  i_trf_origination: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_trf_termination: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  simple_trf_prof: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_trf_profile: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  service_name: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  service_type: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  service_provider: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  ott_classification_type: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  repeated_retransmits: _operators.intOperators,
  receive_window: _operators.intOperators,
  zero_windows: _operators.intOperators,
  connection_id: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  client_nw_latency_ms: _operators.intOperators,
  server_nw_latency_ms: _operators.intOperators,
  appl_latency_ms: _operators.intOperators,
  fpex_latency_ms: _operators.intOperators,
  i_src_provider_classification: _operators.stringOperators,
  i_dst_provider_classification: _operators.stringOperators,
  'i_src|dst_provider_classification': _operators.stringOperators,
  i_ult_provider_classification: _operators.stringOperators,
  /* START AWS Dimensions */
  // src
  kt_aws_src_acc_id: _operators.stringOperators,
  kt_aws_src_vm_name: _operators.stringOperators,
  kt_aws_src_region: _operators.stringOperators,
  kt_aws_src_zone: _operators.stringOperators,
  kt_aws_src_zone_id: _operators.stringOperators,
  kt_aws_src_vm_type: _operators.stringOperators,
  kt_aws_src_image_id: _operators.stringOperators,
  kt_aws_src_sg: _operators.stringOperators,
  kt_aws_src_asg: _operators.stringOperators,
  kt_aws_src_pub_dns: _operators.stringOperators,
  kt_aws_src_priv_dns: _operators.stringOperators,
  kt_aws_src_vpc_id: _operators.stringOperators,
  kt_aws_src_vpc_name: _operators.stringOperators,
  kt_aws_src_subnet_id: _operators.stringOperators,
  kt_aws_src_subnet_name: _operators.stringOperators,
  kt_aws_src_vm_tags: _operators.stringOperators,
  // dst
  kt_aws_dst_acc_id: _operators.stringOperators,
  kt_aws_dst_vm_name: _operators.stringOperators,
  kt_aws_dst_region: _operators.stringOperators,
  kt_aws_dst_zone: _operators.stringOperators,
  kt_aws_dst_zone_id: _operators.stringOperators,
  kt_aws_dst_vm_type: _operators.stringOperators,
  kt_aws_dst_image_id: _operators.stringOperators,
  kt_aws_dst_sg: _operators.stringOperators,
  kt_aws_dst_asg: _operators.stringOperators,
  kt_aws_dst_pub_dns: _operators.stringOperators,
  kt_aws_dst_priv_dns: _operators.stringOperators,
  kt_aws_dst_vpc_id: _operators.stringOperators,
  kt_aws_dst_vpc_name: _operators.stringOperators,
  kt_aws_dst_subnet_id: _operators.stringOperators,
  kt_aws_dst_subnet_name: _operators.stringOperators,
  kt_aws_dst_vm_tags: _operators.stringOperators,
  // src | dst
  'kt_aws_src|dst_acc_id': _operators.stringOperators,
  'kt_aws_src|dst_vm_name': _operators.stringOperators,
  'kt_aws_src|dst_region': _operators.stringOperators,
  'kt_aws_src|dst_zone': _operators.stringOperators,
  'kt_aws_src|dst_zone_id': _operators.stringOperators,
  'kt_aws_src|dst_vm_type': _operators.stringOperators,
  'kt_aws_src|dst_image_id': _operators.stringOperators,
  'kt_aws_src|dst_sg': _operators.stringOperators,
  'kt_aws_src|dst_asg': _operators.stringOperators,
  'kt_aws_src|dst_pub_dns': _operators.stringOperators,
  'kt_aws_src|dst_priv_dns': _operators.stringOperators,
  'kt_aws_src|dst_vpc_id': _operators.stringOperators,
  'kt_aws_src|dst_vpc_name': _operators.stringOperators,
  'kt_aws_src|dst_subnet_id': _operators.stringOperators,
  'kt_aws_src|dst_subnet_name': _operators.stringOperators,
  'kt_aws_src|dst_vm_tags': _operators.stringOperators,
  /* END AWS Dimensions */

  /* START Azure Dimensions */
  // src
  kt_az_src_inst_name: _operators.stringOperators,
  kt_az_src_inst_id: _operators.stringOperators,
  kt_az_src_region: _operators.stringOperators,
  kt_az_src_zone: _operators.intOperators,
  kt_az_src_inst_type: _operators.stringOperators,
  kt_az_src_fqdn: _operators.stringOperators,
  kt_az_src_vnet: _operators.stringOperators,
  kt_az_src_subnet: _operators.stringOperators,
  kt_az_src_rsrc_group: _operators.stringOperators,
  kt_az_src_public_ip: _operators.stringOperators,
  kt_az_src_sub_id: _operators.stringOperators,
  kt_az_src_sub_name: _operators.stringOperators,
  // dst
  kt_az_dst_inst_name: _operators.stringOperators,
  kt_az_dst_inst_id: _operators.stringOperators,
  kt_az_dst_region: _operators.stringOperators,
  kt_az_dst_zone: _operators.intOperators,
  kt_az_dst_inst_type: _operators.stringOperators,
  kt_az_dst_fqdn: _operators.stringOperators,
  kt_az_dst_vnet: _operators.stringOperators,
  kt_az_dst_subnet: _operators.stringOperators,
  kt_az_dst_rsrc_group: _operators.stringOperators,
  kt_az_dst_public_ip: _operators.stringOperators,
  kt_az_dst_sub_id: _operators.stringOperators,
  kt_az_dst_sub_name: _operators.stringOperators,
  // src | dst
  'kt_az_src|dst_inst_name': _operators.stringOperators,
  'kt_az_src|dst_inst_id': _operators.stringOperators,
  'kt_az_src|dst_region': _operators.stringOperators,
  'kt_az_src|dst_zone': _operators.intOperators,
  'kt_az_src|dst_inst_type': _operators.stringOperators,
  'kt_az_src|dst_fqdn': _operators.stringOperators,
  'kt_az_src|dst_vnet': _operators.stringOperators,
  'kt_az_src|dst_subnet': _operators.stringOperators,
  'kt_az_src|dst_rsrc_group': _operators.stringOperators,
  'kt_az_src|dst_public_ip': _operators.stringOperators,
  'kt_az_src|dst_sub_id': _operators.stringOperators,
  'kt_az_src|dst_sub_name': _operators.stringOperators,
  /* END Azure Dimensions */

  /* START K8 Dimensions */
  kt_k8s_src_pod_name: _operators.stringOperators,
  kt_k8s_src_pod_ns: _operators.stringOperators,
  kt_k8s_src_load_name: _operators.stringOperators,
  kt_k8s_src_load_ns: _operators.stringOperators,
  kt_k8s_src_svc_name: _operators.stringOperators,
  kt_k8s_src_svc_ns: _operators.stringOperators,
  kt_k8s_dst_pod_name: _operators.stringOperators,
  kt_k8s_dst_pod_ns: _operators.stringOperators,
  kt_k8s_dst_load_name: _operators.stringOperators,
  kt_k8s_dst_load_ns: _operators.stringOperators,
  kt_k8s_dst_cont_name: _operators.stringOperators,
  kt_k8s_dst_svc_name: _operators.stringOperators,
  kt_k8s_dst_svc_ns: _operators.stringOperators,
  'kt_k8s_src|dst_pod_name': _operators.stringOperators,
  'kt_k8s_src|dst_pod_ns': _operators.stringOperators,
  'kt_k8s_src|dst_load_name': _operators.stringOperators,
  'kt_k8s_src|dst_load_ns': _operators.stringOperators,
  'kt_k8s_src|dst_svc_name': _operators.stringOperators,
  'kt_k8s_src|dst_svc_ns': _operators.stringOperators,
  /* END K8 Dimensions */
  ktrac_prefix_len: {
    '=': 'equals',
    '<>': 'does not equal',
    '<<=': 'is contained within'
  },
  kt_src_dns_hostname: _operators.stringOperators,
  kt_dst_dns_hostname: _operators.stringOperators,
  'kt_src|dst_dns_hostname': _operators.stringOperators,
  c_src_dns_hostname: _operators.stringOperators,
  c_dst_dns_hostname: _operators.stringOperators,
  'c_src|dst_dns_hostname': _operators.stringOperators,
  i_src_asn_member_of_ix: {
    '=': 'equals'
  },
  i_dst_asn_member_of_ix: {
    '=': 'equals'
  },
  'i_src|dst_asn_member_of_ix': {
    '=': 'equals'
  },
  i_src_asn_peering_policy: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_dst_asn_peering_policy: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  'i_src|dst_asn_peering_policy': {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_src_asn_available_at_facility: {
    '=': 'equals'
  },
  i_dst_asn_available_at_facility: {
    '=': 'equals'
  },
  'i_src|dst_asn_available_at_facility': {
    '=': 'equals'
  },
  kt_src_pdb_asn_common_ix: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_dst_pdb_asn_common_ix: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  'kt_src|dst_pdb_asn_common_ix': {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_src_pdb_asn_common_fac: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_dst_pdb_asn_common_fac: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  'kt_src|dst_pdb_asn_common_fac': {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  }
};